import React from "react";
import {
  Grid,
  makeStyles,
  Typography,
  Paper,
  Button,
} from "@material-ui/core";
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import useError from "Hooks/useError";
import MuiAlert from "@material-ui/lab/Alert";
import { message } from "constants/message";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  wrapper: {
    marginTop: theme.spacing(2),
  },
  accountInfo: {
    display: "inline-box",
    width: "120px",
  },
  messsageWrapper: {
    marginTop: theme.spacing(1),
  },
}));

export default function Form({ account, submit, group = null, isEdit = false }) {
  const classes = useStyles();
  const stateError = useError();
  const messages = message();

  const [name, setName] = React.useState("");
  const [priority, setPriority] = React.useState(50);
  const [desc, setDesc] = React.useState("");

  React.useEffect(() => {
    stateError.initialize();
  }, []);

  React.useEffect(() => {
    if (!group) return;
    setName(group.name);
    setPriority(group.priority);
    setDesc(group.desc);
  }, [group]);

  const onError = () => {
    stateError.dispatch({
      type: "set",
      payload: {
        isError: true,
        errorMsg: messages.validation.common,
      },
    });
  };

  return (
    <Grid>
      <Paper elevation={3} className={classes.paper}>
        <Typography variant="h6" color="primary">
          アカウント詳細
        </Typography>
        <Grid container>
          <Grid item xs={12} className={classes.wrapper}>
            <Typography variant="inherit" className={classes.accountInfo}>
              アカウントID
            </Typography>
            <Typography variant="inherit" >
              {account.id}
            </Typography>
          </Grid>
          <Grid item xs={12} className={classes.wrapper}>
            <Typography variant="inherit" className={classes.accountInfo}>
              アカウント名
            </Typography>
            <Typography variant="inherit" >
              {account.name}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
      <ValidatorForm
        onSubmit={(e) => {
          e.preventDefault();
          submit(
            { 
              name,
              priority,
              desc,
            }
          );
        }}
        onError={onError}
      >
        <Paper elevation={3} className={classes.paper}>
          <Typography variant="h6" color="primary">
            {isEdit ? "多メディア収集グループ更新" : "多メディア収集グループ登録"}
          </Typography>
          <Grid container>
            <Grid item xs={12} className={classes.wrapper}>
              <TextValidator
                label="収集グループ名*"
                fullWidth
                value={name}
                onChange={(event) => {
                  setName(event.target.value);
                }}
                type="text"
                validators={['required']}
                errorMessages={[
                  messages.validation.required, 
                ]}
              />
            </Grid>
            <Grid item xs={12} className={classes.wrapper}>
              <TextValidator
                label="表示優先度*"
                fullWidth
                value={priority}
                onChange={(event) => {
                  setPriority(event.target.value);
                }}
                type="number"
                InputProps={{ inputProps: { min: 1} }}
                validators={['required', 'minNumber:1']}
                errorMessages={[
                  messages.validation.required, 
                  ((messages.validation.minNumber).replace("$1", "表示優先度")).replace("$2", "1")
                ]}
              />
            </Grid>
            <Grid item xs={12} className={classes.wrapper}>
              <TextValidator
                label="概要"
                fullWidth
                value={desc}
                onChange={(event) => {
                  setDesc(event.target.value);
                }}
                type="text"
              />
            </Grid>
          </Grid>
        </Paper>
        {stateError.state.isError && (
          <div className={classes.messsageWrapper}>
            <MuiAlert
              elevation={6}
              variant="filled"
              severity="error"
              className={classes.toast}
            >
              {stateError.state.errorMsg}
            </MuiAlert>
          </div>
        )}
        <Grid container justifyContent="center" className={classes.wrapper}>
          <Button type="submit" variant="contained" color="primary">
            {isEdit ? "更新" : "登録"}
          </Button>
        </Grid>
      </ValidatorForm>
    </Grid>
  );
}
